import fb, { getDocsFromCollection } from '@/firebase'
import store from '@/store'
import request from '@/request'

const state = {
  students: null,
  student: null
}

const getters = {
  students: state => state.students,
  student: state => state.student
}

const mutations = {
  setStudents: (state, payload) => {
    state.students = payload
  },
  setStudent: (state, payload) => {
    state.student = payload
  }
}

const actions = {
  getStudents: ({commit}, assocRef) => {
    store.dispatch('setLoaderStatus', true)
    fb.getStudents(assocRef)
      .then((fetched) => {
        commit('setStudents', getDocsFromCollection(fetched))
        console.log(getDocsFromCollection(fetched))
        store.dispatch('setLoaderStatus', false)
      })
  },
  addStudent: ({commit}, payload) => {
    store.dispatch('setLoaderStatus', true)
    request.getNextUserID(payload.personal_details.personal_email)
      .then(response => {
        response.json().then(data => {
          payload['seq_id'] = data.next_id

          fb.addStudent(payload)
            .then((response) => {
              store.dispatch('setLoaderStatus', false)
              store.dispatch('setSuccessMessage', 'Student personal details saved successfully')
              store.dispatch('getStudent', response.id)
              store.dispatch('getStudents', payload.associate)
            })
        })
      })
  },
  getStudent: ({commit}, id) => {
    store.dispatch('setLoaderStatus', true)
    fb.getStudentDetails(id)
      .then((fetched) => {
        const docData = fetched.data()
        const details = {...docData, ...{id: fetched.id, ref: fetched.ref}}
        commit('setStudent', details)
        store.dispatch('setLoaderStatus', false)
      })
  },
  updateStudent: ({ commit }, params) => {
    store.dispatch('setLoaderStatus', true)
    fb.updateStudentDetails(params.id, params.payload)
      .then(() => {
        store.dispatch('setLoaderStatus', false)
        store.dispatch('setSuccessMessage', 'Details saved successfully')
        store.dispatch('getStudent', params.id)
        store.dispatch('getStudents', params.associate)
      })
  },
  addStudentDocument: ({commit}, params) => {
    store.dispatch('setLoaderStatus', true)
    fb.uploadDocument(params.document)
      .then((snapshot) => {
        fb.updateStudentDocuments(params.id, {
          doc: {url: snapshot.downloadURL, name: snapshot.metadata.name}
        }).then(() => {
          store.dispatch('setLoaderStatus', false)
          store.dispatch('setSuccessMessage', 'Document saved successfully')
          if (params.associate) {
            store.dispatch('getStudents', params.associate)
          } else {
            store.dispatch('getStudent', params.id)
          }
        })
      })
  },
  deleteStudentDocument: ({commit}, params) => {
    store.dispatch('setLoaderStatus', true)
    fb.deleteDocument(params.document)
      .then((snapshot) => {
        fb.deleteStudentDocument(params.id, params.document).then(() => {
          store.dispatch('setLoaderStatus', false)
          store.dispatch('setSuccessMessage', 'Document deleted successfully')
          store.dispatch('getStudent', params.id)
        })
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/students.js